import React from 'react';

const DefaultLayout = ({ children }) => {
  return <>{children}</>;
};

export default DefaultLayout;
